import { DeliveryAnalyticsTotalsSchema } from "@redotech/redo-model/analytics/analytics";
import * as z from "zod";

export const getDeliveryAnalytics = {
  name: "getDeliveryAnalytics",
  input: z.object({
    numUnits: z.number().positive(),
    startDate: z.date(),
    pageSize: z.number().positive().optional(),
    pageNumber: z.number().positive().optional(),
  }),
  output: DeliveryAnalyticsTotalsSchema,
};
